const defaultPrefix = 'bh-';
const components = {
    "a": {
        "originalName": "bh-a",
        "tagNameBase": "a",
        "className": "BhA"
    },
    "accordion": {
        "originalName": "bh-accordion",
        "tagNameBase": "accordion",
        "className": "BhAccordion"
    },
    "actionBar": {
        "originalName": "bh-action-bar",
        "tagNameBase": "action-bar",
        "className": "BhActionBar"
    },
    "actionMenu": {
        "originalName": "bh-action-menu",
        "tagNameBase": "action-menu",
        "className": "BhActionMenu"
    },
    "alert": {
        "originalName": "bh-alert",
        "tagNameBase": "alert",
        "className": "BhAlert"
    },
    "alertItem": {
        "originalName": "bh-alert-item",
        "tagNameBase": "alert-item",
        "className": "BhAlertItem"
    },
    "appShell": {
        "originalName": "bh-app-shell",
        "tagNameBase": "app-shell",
        "className": "BhAppShell"
    },
    "appShellMenu": {
        "originalName": "bh-app-shell-menu",
        "tagNameBase": "app-shell-menu",
        "className": "BhAppShellMenu"
    },
    "avatar": {
        "originalName": "bh-avatar",
        "tagNameBase": "avatar",
        "className": "BhAvatar"
    },
    "avatarGroup": {
        "originalName": "bh-avatar-group",
        "tagNameBase": "avatar-group",
        "className": "BhAvatarGroup"
    },
    "badge": {
        "originalName": "bh-badge",
        "tagNameBase": "badge",
        "className": "BhBadge"
    },
    "barChart": {
        "originalName": "bh-bar-chart",
        "tagNameBase": "bar-chart",
        "className": "BhBarChart"
    },
    "breadcrumbs": {
        "originalName": "bh-breadcrumbs",
        "tagNameBase": "breadcrumbs",
        "className": "BhBreadcrumbs"
    },
    "button": {
        "originalName": "bh-button",
        "tagNameBase": "button",
        "className": "BhButton"
    },
    "buttonDropdown": {
        "originalName": "bh-button-dropdown",
        "tagNameBase": "button-dropdown",
        "className": "BhButtonDropdown"
    },
    "buttonGroup": {
        "originalName": "bh-button-group",
        "tagNameBase": "button-group",
        "className": "BhButtonGroup"
    },
    "buttonTabs": {
        "originalName": "bh-button-tabs",
        "tagNameBase": "button-tabs",
        "className": "BhButtonTabs"
    },
    "card": {
        "originalName": "bh-card",
        "tagNameBase": "card",
        "className": "BhCard"
    },
    "checkbox": {
        "originalName": "bh-checkbox",
        "tagNameBase": "checkbox",
        "className": "BhCheckbox"
    },
    "chip": {
        "originalName": "bh-chip",
        "tagNameBase": "chip",
        "className": "BhChip"
    },
    "chipGroup": {
        "originalName": "bh-chip-group",
        "tagNameBase": "chip-group",
        "className": "BhChipGroup"
    },
    "content": {
        "originalName": "bh-content",
        "tagNameBase": "content",
        "className": "BhContent"
    },
    "customTimePicker": {
        "originalName": "bh-custom-time-picker",
        "tagNameBase": "custom-time-picker",
        "className": "BhCustomTimePicker"
    },
    "dataTable": {
        "originalName": "bh-data-table",
        "tagNameBase": "data-table",
        "className": "BhDataTable"
    },
    "datePicker": {
        "originalName": "bh-date-picker",
        "tagNameBase": "date-picker",
        "className": "BhDatePicker"
    },
    "dateRangePicker": {
        "originalName": "bh-date-range-picker",
        "tagNameBase": "date-range-picker",
        "className": "BhDateRangePicker"
    },
    "dateTimePicker": {
        "originalName": "bh-date-time-picker",
        "tagNameBase": "date-time-picker",
        "className": "BhDateTimePicker"
    },
    "datetimeRangePicker": {
        "originalName": "bh-datetime-range-picker",
        "tagNameBase": "datetime-range-picker",
        "className": "BhDatetimeRangePicker"
    },
    "dialog": {
        "originalName": "bh-dialog",
        "tagNameBase": "dialog",
        "className": "BhDialog"
    },
    "divider": {
        "originalName": "bh-divider",
        "tagNameBase": "divider",
        "className": "BhDivider"
    },
    "donutChart": {
        "originalName": "bh-donut-chart",
        "tagNameBase": "donut-chart",
        "className": "BhDonutChart"
    },
    "dropdown": {
        "originalName": "bh-dropdown",
        "tagNameBase": "dropdown",
        "className": "BhDropdown"
    },
    "error": {
        "originalName": "bh-error",
        "tagNameBase": "error",
        "className": "BhError"
    },
    "footer": {
        "originalName": "bh-footer",
        "tagNameBase": "footer",
        "className": "BhFooter"
    },
    "formMessage": {
        "originalName": "bh-form-message",
        "tagNameBase": "form-message",
        "className": "BhFormMessage"
    },
    "header": {
        "originalName": "bh-header",
        "tagNameBase": "header",
        "className": "BhHeader"
    },
    "icon": {
        "originalName": "bh-icon",
        "tagNameBase": "icon",
        "className": "BhIcon"
    },
    "illustration": {
        "originalName": "bh-illustration",
        "tagNameBase": "illustration",
        "className": "BhIllustration"
    },
    "incrementer": {
        "originalName": "bh-incrementer",
        "tagNameBase": "incrementer",
        "className": "BhIncrementer"
    },
    "inlineDropdown": {
        "originalName": "bh-inline-dropdown",
        "tagNameBase": "inline-dropdown",
        "className": "BhInlineDropdown"
    },
    "kpi": {
        "originalName": "bh-kpi",
        "tagNameBase": "kpi",
        "className": "BhKpi"
    },
    "lineChart": {
        "originalName": "bh-line-chart",
        "tagNameBase": "line-chart",
        "className": "BhLineChart"
    },
    "list": {
        "originalName": "bh-list",
        "tagNameBase": "list",
        "className": "BhList"
    },
    "menu": {
        "originalName": "bh-menu",
        "tagNameBase": "menu",
        "className": "BhMenu"
    },
    "menuItem": {
        "originalName": "bh-menu-item",
        "tagNameBase": "menu-item",
        "className": "BhMenuItem"
    },
    "mobileMenu": {
        "originalName": "bh-mobile-menu",
        "tagNameBase": "mobile-menu",
        "className": "BhMobileMenu"
    },
    "modal": {
        "originalName": "bh-modal",
        "tagNameBase": "modal",
        "className": "BhModal"
    },
    "navMenu": {
        "originalName": "bh-nav-menu",
        "tagNameBase": "nav-menu",
        "className": "BhNavMenu"
    },
    "pagination": {
        "originalName": "bh-pagination",
        "tagNameBase": "pagination",
        "className": "BhPagination"
    },
    "panel": {
        "originalName": "bh-panel",
        "tagNameBase": "panel",
        "className": "BhPanel"
    },
    "progressBar": {
        "originalName": "bh-progress-bar",
        "tagNameBase": "progress-bar",
        "className": "BhProgressBar"
    },
    "radioButton": {
        "originalName": "bh-radio-button",
        "tagNameBase": "radio-button",
        "className": "BhRadioButton"
    },
    "scatterChart": {
        "originalName": "bh-scatter-chart",
        "tagNameBase": "scatter-chart",
        "className": "BhScatterChart"
    },
    "search": {
        "originalName": "bh-search",
        "tagNameBase": "search",
        "className": "BhSearch"
    },
    "selectionGroup": {
        "originalName": "bh-selection-group",
        "tagNameBase": "selection-group",
        "className": "BhSelectionGroup"
    },
    "settingsMenu": {
        "originalName": "bh-settings-menu",
        "tagNameBase": "settings-menu",
        "className": "BhSettingsMenu"
    },
    "slider": {
        "originalName": "bh-slider",
        "tagNameBase": "slider",
        "className": "BhSlider"
    },
    "spinner": {
        "originalName": "bh-spinner",
        "tagNameBase": "spinner",
        "className": "BhSpinner"
    },
    "statusIndicator": {
        "originalName": "bh-status-indicator",
        "tagNameBase": "status-indicator",
        "className": "BhStatusIndicator"
    },
    "stepper": {
        "originalName": "bh-stepper",
        "tagNameBase": "stepper",
        "className": "BhStepper"
    },
    "systemAlertItem": {
        "originalName": "bh-system-alert-item",
        "tagNameBase": "system-alert-item",
        "className": "BhSystemAlertItem"
    },
    "tabs": {
        "originalName": "bh-tabs",
        "tagNameBase": "tabs",
        "className": "BhTabs"
    },
    "tabularList": {
        "originalName": "bh-tabular-list",
        "tagNameBase": "tabular-list",
        "className": "BhTabularList"
    },
    "textArea": {
        "originalName": "bh-text-area",
        "tagNameBase": "text-area",
        "className": "BhTextArea"
    },
    "textInput": {
        "originalName": "bh-text-input",
        "tagNameBase": "text-input",
        "className": "BhTextInput"
    },
    "timePicker": {
        "originalName": "bh-time-picker",
        "tagNameBase": "time-picker",
        "className": "BhTimePicker"
    },
    "timeZonePicker": {
        "originalName": "bh-time-zone-picker",
        "tagNameBase": "time-zone-picker",
        "className": "BhTimeZonePicker"
    },
    "titleWrapper": {
        "originalName": "bh-title-wrapper",
        "tagNameBase": "title-wrapper",
        "className": "BhTitleWrapper"
    },
    "toggle": {
        "originalName": "bh-toggle",
        "tagNameBase": "toggle",
        "className": "BhToggle"
    },
    "tokenDemo": {
        "originalName": "bh-token-demo",
        "tagNameBase": "token-demo",
        "className": "BhTokenDemo"
    },
    "tooltip": {
        "originalName": "bh-tooltip",
        "tagNameBase": "tooltip",
        "className": "BhTooltip"
    },
    "tree": {
        "originalName": "bh-tree",
        "tagNameBase": "tree",
        "className": "BhTree"
    },
    "typeAhead": {
        "originalName": "bh-type-ahead",
        "tagNameBase": "type-ahead",
        "className": "BhTypeAhead"
    },
    "uploader": {
        "originalName": "bh-uploader",
        "tagNameBase": "uploader",
        "className": "BhUploader"
    },
    "verticalMenu": {
        "originalName": "bh-vertical-menu",
        "tagNameBase": "vertical-menu",
        "className": "BhVerticalMenu"
    }
};
const generateComponentLiteralWithPrefix = (prefix) => {
    const literals = { a: '',
        accordion: '',
        actionBar: '',
        actionMenu: '',
        alert: '',
        alertItem: '',
        appShell: '',
        appShellMenu: '',
        avatar: '',
        avatarGroup: '',
        badge: '',
        barChart: '',
        breadcrumbs: '',
        button: '',
        buttonDropdown: '',
        buttonGroup: '',
        buttonTabs: '',
        card: '',
        checkbox: '',
        chip: '',
        chipGroup: '',
        content: '',
        customTimePicker: '',
        dataTable: '',
        datePicker: '',
        dateRangePicker: '',
        dateTimePicker: '',
        datetimeRangePicker: '',
        dialog: '',
        divider: '',
        donutChart: '',
        dropdown: '',
        error: '',
        footer: '',
        formMessage: '',
        header: '',
        icon: '',
        illustration: '',
        incrementer: '',
        inlineDropdown: '',
        kpi: '',
        lineChart: '',
        list: '',
        menu: '',
        menuItem: '',
        mobileMenu: '',
        modal: '',
        navMenu: '',
        pagination: '',
        panel: '',
        progressBar: '',
        radioButton: '',
        scatterChart: '',
        search: '',
        selectionGroup: '',
        settingsMenu: '',
        slider: '',
        spinner: '',
        statusIndicator: '',
        stepper: '',
        systemAlertItem: '',
        tabs: '',
        tabularList: '',
        textArea: '',
        textInput: '',
        timePicker: '',
        timeZonePicker: '',
        titleWrapper: '',
        toggle: '',
        tokenDemo: '',
        tooltip: '',
        tree: '',
        typeAhead: '',
        uploader: '',
        verticalMenu: '',
    };
    Object.keys(literals).forEach(key => {
        literals[key] = prefix + components[key].tagNameBase;
    });
    return literals;
};

export { components as c, defaultPrefix as d, generateComponentLiteralWithPrefix as g };

